var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 159,
    viewBox: "0 0 173 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.254 58.7198C103.993 58.7198 91.5416 58.2223 79.8805 54.9742C68.439 51.7846 57.9338 45.6395 48.5699 38.5142C42.4248 33.8615 36.865 30.1744 28.891 30.7304C21.1134 31.1373 13.6718 34.0298 7.66118 38.9824C-2.4782 47.8488 -0.941932 64.2504 3.09627 75.7797C9.19745 93.1469 27.7059 105.218 43.4636 113.075C61.6501 122.16 81.6216 127.486 101.666 130.412C119.224 133.09 141.77 135.021 156.987 123.55C170.974 113.016 174.807 88.9624 171.384 72.7218C170.552 67.921 167.991 63.5908 164.185 60.5487C154.368 53.3648 139.722 58.1638 128.69 58.3979C124.593 58.5442 120.438 58.7198 116.254 58.7198Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2734 158.943C115.937 158.943 139.984 157.443 139.984 155.593C139.984 153.742 115.937 152.242 86.2734 152.242C56.6097 152.242 32.5625 153.742 32.5625 155.593C32.5625 157.443 56.6097 158.943 86.2734 158.943Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.043 38.0025C163.835 38.0025 164.477 37.3605 164.477 36.5686C164.477 35.7767 163.835 35.1348 163.043 35.1348C162.251 35.1348 161.609 35.7767 161.609 36.5686C161.609 37.3605 162.251 38.0025 163.043 38.0025Z",
    fill: "#CFCFCF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.211 27.7906C102.003 27.7906 102.645 27.1486 102.645 26.3567C102.645 25.5648 102.003 24.9229 101.211 24.9229C100.419 24.9229 99.7773 25.5648 99.7773 26.3567C99.7773 27.1486 100.419 27.7906 101.211 27.7906Z",
    fill: "#CFCFCF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9453 120.757V127.048",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7969 123.901H47.0883",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8711 1V7.2914",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7109 4.14551H24.017",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.922 33.4092V39.7152",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.777 36.5693H138.069",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9763 117.655C84.7355 127.104 94.9656 133.489 106.424 135.409C117.883 137.329 129.635 134.627 139.105 127.896C140.276 127.066 141.404 126.177 142.485 125.234L159.94 130.515L153.254 110.983C156.591 103.996 158.021 96.2506 157.399 88.5325C156.776 80.8145 154.123 73.3985 149.708 67.0372C145.293 60.6758 139.275 55.5955 132.262 52.3117C125.25 49.0279 117.494 47.6575 109.781 48.3396C102.068 49.0217 94.6724 51.732 88.3452 56.1955C82.018 60.659 76.9842 66.7168 73.7545 73.7541C70.5248 80.7915 69.2142 88.5581 69.9556 96.2656C70.6971 103.973 73.4643 111.347 77.9763 117.64V117.655Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.85 95.0937C130.45 95.0937 131.747 93.7967 131.747 92.1968C131.747 90.5968 130.45 89.2998 128.85 89.2998C127.25 89.2998 125.953 90.5968 125.953 92.1968C125.953 93.7967 127.25 95.0937 128.85 95.0937Z",
    fill: "#BABABA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.877 95.0937C116.477 95.0937 117.774 93.7967 117.774 92.1968C117.774 90.5968 116.477 89.2998 114.877 89.2998C113.277 89.2998 111.98 90.5968 111.98 92.1968C111.98 93.7967 113.277 95.0937 114.877 95.0937Z",
    fill: "#BABABA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.92 95.0937C102.52 95.0937 103.817 93.7967 103.817 92.1968C103.817 90.5968 102.52 89.2998 100.92 89.2998C99.3205 89.2998 98.0234 90.5968 98.0234 92.1968C98.0234 93.7967 99.3205 95.0937 100.92 95.0937Z",
    fill: "#BABABA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92.284 87.7933C85.5248 97.2431 75.2948 103.628 63.8362 105.547C52.3776 107.467 40.6252 104.766 31.1551 98.0351C29.9812 97.2091 28.853 96.3202 27.7753 95.3722L10.3203 100.683L17.0067 81.1361C13.6691 74.1493 12.239 66.4039 12.8617 58.6859C13.4844 50.9678 16.1377 43.5518 20.5523 37.1905C24.9669 30.8291 30.9858 25.7488 37.9981 22.465C45.0104 19.1812 52.7666 17.8108 60.4796 18.4929C68.1926 19.175 75.5879 21.8853 81.9151 26.3488C88.2423 30.8123 93.2762 36.8701 96.5059 43.9075C99.7356 50.9449 101.046 58.7114 100.305 66.4189C99.5632 74.1264 96.7961 81.5007 92.284 87.7933Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 70.835C45.4194 68.642 47.2618 66.8212 49.4699 65.5488C51.6781 64.2764 54.1773 63.5955 56.7257 63.5719C59.2741 63.5484 61.7854 64.183 64.0167 65.4144C66.248 66.6458 68.1237 68.4322 69.4622 70.6009",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1919 57.9736C74.3313 57.9736 75.2549 57.05 75.2549 55.9107C75.2549 54.7713 74.3313 53.8477 73.1919 53.8477C72.0525 53.8477 71.1289 54.7713 71.1289 55.9107C71.1289 57.05 72.0525 57.9736 73.1919 57.9736Z",
    fill: "#BABABA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5083 57.9736C41.6477 57.9736 42.5713 57.05 42.5713 55.9107C42.5713 54.7713 41.6477 53.8477 40.5083 53.8477C39.3689 53.8477 38.4453 54.7713 38.4453 55.9107C38.4453 57.05 39.3689 57.9736 40.5083 57.9736Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChats);
export default __webpack_public_path__ + "static/media/emptyChats.f7cffcb2c9495d95a350d5bff8932e1e.svg";
export { ForwardRef as ReactComponent };